"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExpandableRow = _interopRequireDefault(require("../ExpandableRow/ExpandableRow"));

var _propTypes2 = require("../propTypes");

var TableBody =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TableBody, _Component);

  function TableBody() {
    (0, _classCallCheck2.default)(this, TableBody);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableBody).apply(this, arguments));
  }

  (0, _createClass2.default)(TableBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          renderRow = _this$props.renderRow,
          indentLevel = _this$props.indentLevel,
          onExpandRow = _this$props.onExpandRow,
          draggable = _this$props.draggable,
          expandedKeys = _this$props.expandedKeys;
      return data.map(function (rowData, index) {
        return _react.default.createElement(_ExpandableRow.default, {
          key: rowData.__key,
          rowData: rowData,
          indentLevel: indentLevel,
          partiallyAppliedRenderRow: function partiallyAppliedRenderRow(rowExpandOptions) {
            return renderRow(rowData, index, indentLevel, rowExpandOptions);
          },
          renderRow: renderRow,
          onExpandRow: onExpandRow,
          draggable: draggable,
          expandedKeys: expandedKeys
        });
      });
    }
  }]);
  return TableBody;
}(_react.Component);

TableBody.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes2.rowPropType).isRequired,
  renderRow: _propTypes.default.func.isRequired,
  indentLevel: _propTypes.default.number.isRequired,
  onExpandRow: _propTypes.default.func.isRequired,
  expandedKeys: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = TableBody;
exports.default = _default;